export default {
  TableHead: [
    [
      {
        displayName: 'activity.number',
      },
      {
        displayName: 'activity.username',
      },
      {
        displayName: 'activity.ipaddress',
      },
      {
        displayName: 'activity.type',
      },
      {
        displayName: 'activity.datetime',
      },
    ],
  ],
};
